import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

//app
import { User } from 'solar-bo';
import { UserService } from '../user.service';
import { MatDialogConfig, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatListOption } from '@angular/material/list';
import { UserChangepwdComponent } from '../user-edit/user-changepwd.component';
import { UserEditComponent } from '../user-edit/user-edit.component';
import { UserSitesListComponent } from '../user-sites/user-sites-list.component';
import { EditBaseComponent } from '@solar/shared/edit-base.component';
import { Site } from 'solar-bo';

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.scss']
})
export class UserDetailComponent extends EditBaseComponent implements OnInit {

  @Input() id_user: string;
  model: User = new User();
  @ViewChild('editform') editform: UserEditComponent;
  @ViewChild('sitesAsigned') sitesAsignedComponent: UserSitesListComponent;
  constructor(
    private baseService: UserService
    , public route: ActivatedRoute) {
    super();
    this.model.id = "-1";
  }

  ngOnInit() {
    this.getViewModel();

  }

  getViewModel(): void {
    let id = this.route.snapshot.paramMap.get('id');
    if (this.id_user != null) {
      id=this.id_user;
    } else if (id == '-1') {
      return;
    }

    if (id==null){
      return;
    }
    this.baseService.getUser(id)
      .subscribe(resmodel => this.handleresult(resmodel));
  }
  handleresult(resmodel: any) {
    this.loading = false;
    this.model = resmodel;
    console.log("UserDetailComponent getViewModel handleresult :", this.model);
  }

  isvalid() {
    if (this.editform != null) {//en el inicio no es accesible
      return this.editform.isvalid();
    }
    else {
      return false;
    }

  }
  saveModel() {
    this.alertmessage = null;
    let user: User = this.model;
    user.info.sites = [];
    let asign: MatListOption[] = this.sitesAsignedComponent.selectionGetSelected();
    for (let as of asign) {
      let site = as.value;
      user.info.sites.push(site);
    }

    this.editform.saveModel(this);
  }

  changepwd_openmodal() {
    this.openChangePwdModal(this.dialog, this.model);
  }


  public openChangePwdModal(dialog: MatDialog, model: User): MatDialogRef<any> {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "400px";
    dialogConfig.data = { component: UserChangepwdComponent, model: model };

    let dialogRef: MatDialogRef<UserChangepwdComponent>;
    dialogRef = dialog.open(UserChangepwdComponent, dialogConfig);
    return dialogRef;
  }

}
